import { Injectable } from "@angular/core";
import { SupportRepository } from "../infrastructure/repositories/support.repository";
import { Observable, of } from "rxjs";
import { OpeningHours } from "../model/interfaces/opening-hours";
import { SupportMessage } from "../model/interfaces/support-message";
import { SupportMessageResponse } from "../model/api/api-request/support-message-response";

@Injectable( { providedIn: 'root' })
export class SupportService
{
    private readonly supportRepository: SupportRepository;

    private openingHours: OpeningHours = {
        Monday: { Opens: "09:00", Closes: "18:00" },
        Tuesday:  { Opens: "09:00", Closes: "18:00" },
        Wednesday:  { Opens: "09:00", Closes: "18:00" },
        Thursday:  { Opens: "09:00", Closes: "18:00" },
        Friday:  { Opens: "09:00", Closes: "18:00" },
        Saturday: null,
        Sunday: null
    };

    public constructor(supportRepository: SupportRepository)
    {
        this.supportRepository = supportRepository;
    }

    public getOpeningHours(): Observable<OpeningHours>
    {
        if(this.openingHours != null)
        {
            return of(this.openingHours)
        }

        /*
        return this.supportRepository.getOpeningHours().pipe(map((openingHours)=> { 
            this.openingHours = openingHours;
            return openingHours;
        }));
        */
    }

    public sendMessage(messageObject: SupportMessage): Observable<SupportMessageResponse>
    {
        return this.supportRepository.sendMessage(messageObject);
    }
}
